// extracted by mini-css-extract-plugin
export default {"inputContainerUnique":"ArquivamentoSolic_inputContainerUnique__k-CPB","descricao":"ArquivamentoSolic_descricao__t3hhY","divPrincipal":"ArquivamentoSolic_divPrincipal__yiRsb"};